export enum VisitConfirmedStatus {
  Unconfirmed = 0,
  StaffConfirmed = 1,
  EmailConfirmed = 2,
  SMSConfirmed = 3,
}
